import { useRef, useEffect } from 'react';

const subscribers = /* @__PURE__ */ new Set();
function usePollyIntegration(targetRef, onBeforePollyStarted) {
  const handleBeforePollyStarted = (context) => {
    const target = targetRef.current;
    if (context.type === "range") {
      if (!target) {
        return;
      }
      const willBeReadOutLoud = context.range.commonAncestorContainer.contains(target);
      if (!willBeReadOutLoud) {
        return;
      }
    }
    onBeforePollyStarted(context);
  };
  const stableCb = useRef(handleBeforePollyStarted);
  stableCb.current = handleBeforePollyStarted;
  useEffect(() => {
    subscribers.add(stableCb);
    return () => {
      subscribers.delete(stableCb);
    };
  }, []);
}
async function executeIntegrationCallbacks(context) {
  await Promise.all(
    [...subscribers.values()].map((ref) => {
      var _a;
      return (_a = ref.current) == null ? void 0 : _a.call(ref, context);
    })
  );
}

export { executeIntegrationCallbacks, usePollyIntegration };
//# sourceMappingURL=hook.integration.js.map
